import React from "react";
import { Button } from "@mui/material";

function TablePagination({ currentPage, totalPages, handleFirstPage, handlePrevPage, handleNextPage, handleLastPage }) {
  return (
    <div className="d-flex justify-content-end align-items-center mt-3 mb-3">
      <Button variant="outlined"
        size="small" className="me-2" onClick={handleFirstPage} disabled={currentPage === 1}>First</Button>
      <Button variant="outlined"
        size="small" className="me-2" onClick={handlePrevPage} disabled={currentPage === 1}>Prev</Button>
      <span style={{ margin: '0 8px' }}>Page {currentPage} of {totalPages}</span>
      <Button variant="outlined"
        size="small" className="me-2" onClick={handleNextPage} disabled={currentPage >= totalPages || totalPages === 0}>Next</Button>
      <Button variant="outlined"
        size="small"  onClick={handleLastPage} disabled={currentPage >= totalPages || totalPages === 0}>Last</Button>
    </div>
  );
}

export default TablePagination;
